// extracted by mini-css-extract-plugin
module.exports = {"list":"RegistersList_list__UDRBd","container":"RegistersList_container__1q_Mw","button":"RegistersList_button__2dQar"};